export type EventType = 'MARATHON' | 'TRAIL_RUN';

export const EVENT_TYPE_META: Record<
  EventType,
  { label: string; fg: string; bg: string; solid: string }
> = {
  MARATHON: {
    label: '마라톤',
    fg: '#57534e',
    bg: '#f5f5f4',
    solid: 'rgba(120,113,108,0.8)',
  },
  TRAIL_RUN: {
    label: '트레일런',
    fg: '#0f766e',
    bg: '#f0fdfa',
    solid: 'rgba(13,148,136,0.75)',
  },
};
